
import request from '@/utils/request'
export default {
  getinfo(data) {
    //首页数据
    return request({
      url: '/api/demo/show_dataone',
      method: 'post',
      data
    })
  },
  config() {
    return request({
      url: '/api/demo/config',
      method: 'post'
    })
  },
	rz_list() {
	  return request({
	    url: '/api/index/rz_list',
	    method: 'post'
	  })
	},
  home_policy() {
    return request({
      url: '/api/demo/home_policy',
      method: 'post'
    })
  },
  start_list(data) {
    return request({
      url: '/api/demo/start_list',
      method: 'post',
      data
    })
  },
  article_list(data) {
    return request({
      url: '/api/demo/article_list',
      method: 'post',
      data
    })
  },
  lease_list(data) {
    return request({
      url: '/api/demo/lease_list',
      method: 'post',
      data
    })
  },
  partner_list() {
    return request({
      url: '/api/demo/partner_list',
      method: 'post'
    })
  },
  article_detail(data) {
    return request({
      url: '/api/demo/article_detail',
      method: 'post',
      data
    })
  },
  server_detail(data) {
    return request({
      url: '/api/index/server_detail',
      method: 'post',
      data
    })
  },
  server_list(data) {
    return request({
      url: '/api/index/server_list',
      method: 'post',
      data
    })
  },
  tech_category(data) {
    return request({
      url: '/api/demo/tech_category',
      method: 'post',
      data
    })
  },
  tech_list(data) {
    return request({
      url: '/api/demo/tech_list',
      method: 'post',
      data
    })
  },
  tech_detail(data) {
    return request({
      url: '/api/demo/tech_detail',
      method: 'post',
      data
    })
  },
  question_add(data) {
    return request({
      url: '/api/index/question_add',
      method: 'post',
      data
    })
  },
  train_category() {
    return request({
      url: '/api/demo/train_category',
      method: 'post'
    })
  },
  train_list(data) {
    return request({
      url: '/api/demo/train_list',
      method: 'post',
      data
    })
  },
  train_detail(data) {
    return request({
      url: '/api/demo/train_detail',
      method: 'post',
      data
    })
  },
  start_detail(data) {
    return request({
      url: '/api/demo/start_detail',
      method: 'post',
      data
    })
  },
  finance_list(data) {
    return request({
      url: '/api/demo/finance_list',
      method: 'post',
      data
    })
  },
   
  notice_list(data) {
    return request({
      url: '/api/demo/notice_list',
      method: 'post',
      data
    })
  },
  policy_list(data) {
    return request({
      url: '/api/demo/policy_list',
      method: 'post',
      data
    })
  },
	type_list(data) {
	  return request({
	    url: '/api/demo/type_list',
	    method: 'post',
	    data
	  })
	},
  finance_detail(data) {
    return request({
      url: '/api/demo/finance_detail',
      method: 'post',
      data
    })
  },
  shop_list(data) {
    return request({
      url: '/api/index/shop_list',
      method: 'post',
      data
    })
  },
  shop_detail(data) {
    return request({
      url: '/api/index/shop_detail',
      method: 'post',
      data
    })
  },
  getRegionList(data) {
    return request({
      url: '/api/demo/getRegionList',
      method: 'post',
      data
    })
  },
  shop_category() {
    return request({
      url: '/api/index/shop_category',
      method: 'post'
    })
  },
  upload() {
    return request({
      url: '/api/common/upload',
      method: 'post'
    })
  },
  admin_login(data) {
    return request({
      url: '/api/user/admin_login',
      method: 'post',
      data
    })
  },
  shop_submit(data) {
    return request({
      url: '/api/index/shop_submit',
      method: 'post',
      data
    })
  },
  my_room(data) {
    return request({
      url: '/api/index/my_room',
      method: 'post',
      data
    })
  },
  my_question(data) {
    return request({
      url: '/api/index/my_question',
      method: 'post',
      data
    })
  },
  search_list(data) {
    return request({
      url: '/api/index/search_list',
      method: 'post',
      data
    })
  },
  intro_edit(data) {
    return request({
      url: '/api/index/intro_edit',
      method: 'post',
      data
    })
  },
  lease_detail(data) {
    return request({
      url: '/api/demo/lease_detail',
      method: 'post',
      data
    })
  },
  my_ortherroom(data) {
    return request({
      url: '/api/index/my_ortherroom',
      method: 'post',
      data
    })
  },
  my_record(data) {
    return request({
      url: '/api/index/my_record',
      method: 'post',
      data
    })
  },
  feedback_list(data) {
    return request({
      url: '/api/demo/feedback_list',
      method: 'post',
      data
    })
  },
  feedback(data) {
    return request({
      url: '/api/demo/feedback',
      method: 'post',
      data
    })
  },
  shop_rand(data) {
    return request({
      url: '/api/index/shop_rand',
      method: 'post',
      data
    })
  },

  getcyfulist(data) {
    return request({
      url: '/api/demo/cyfulist',
      method: 'post',
      data
    })
  },
  getarealist(data) {
    return request({
      url: '/api/demo/arealist',
      method: 'post',
      data
    })
  },
  getquanlist(data) {
    return request({
      url: '/api/index/quanlist',
      method: 'post',
      data
    })
  }

  // https://ms.daoben.tech/api/index/shop_rand
}



// WEBPACK FOOTER //
// ./src/api/index.js